import { styled } from "@mui/material";
import { rem } from "polished";
import React, { type ReactNode } from "react";

export const amountCellWidth = 150;

type Props = {
  header: ReactNode;
  children: ReactNode;
  ariaLabel?: string;
};

const StyledExpenseTable = styled("table")`
  width: 100%;
  border-collapse: collapse;
`;

const StyledExpenseHeader = styled("tr")`
  background: ${(props) => props.theme.palette.table.expendedComponent};

  > th {
    font-weight: 500;
    padding: ${(props) => props.theme.spacing(1.5)};

    &:nth-of-type(1) {
      width: 5%;
    }
    &:nth-of-type(2) {
      width: 10%;
      text-align: center;
    }
    &:nth-of-type(4),
    &:nth-of-type(5),
    &:nth-of-type(6) {
      text-align: center;
      width: ${rem(amountCellWidth)};
    }
  }
`;

export const ExpenseTable = ({ header, children, ariaLabel }: Props) => (
  <StyledExpenseTable aria-label={ariaLabel}>
    <thead>
      <StyledExpenseHeader>{header}</StyledExpenseHeader>
    </thead>
    <tbody>{children}</tbody>
  </StyledExpenseTable>
);
